<template>
  <div class="page--login">
    <div class="login-left">
      <img class="login-bg" src="../../assets/images/login-pic.jpg">
      <img class="login-bg-m" src="../../assets/images/login-pic-m.jpg">
    </div>

    <div class="login-right">
      <div class="login-right-content">
        <!-- step 4 -->
          <div class="section-header">
            <h1>Choose account</h1>
            <form class="form--oneliner">
              <div class="input-wrapper">
                <input type="text" v-model="search" placeholder="Search...">
              </div>
              <button @click.prevent style="margin: unset"><i class="icon-search"></i></button>
            </form>
          </div>
          <div class="boxes-row boxes-row--accounts">
            <a class="box" v-for="company in companies" :key="company.idCompany" @click="selectCompany(company)">
              <ImageWrapper :file="company.idLogo"></ImageWrapper>
              <span class="box-title">{{ company.name }}</span>
            </a>
          </div>
      </div>
      <div class="login-footer">All rights reserved by Capgemini. <br>Copyright © {{ new Date().getFullYear() }}</div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import {slugify} from "@/helpers/slugify";
export default {
name: "SelectCompany",
  components: {ImageWrapper},
  data() {
    return {
      search: ''
    }
  },
  computed: {
    companies() {
      if(this.search) {
        return this.$store.getters.userCompanies.filter(company => company.name.toLowerCase().includes(this.search.toLowerCase()))
      }
      return this.$store.getters.userCompanies
    },
    publicCompanies() {
      return this.$store.getters.publicCompanies
    }
},
mounted() {
  if(this.companies.length === 1 && !this.publicCompanies.length) {
    this.trackUserAndCompany(this.companies[0])
    this.selectCompany(this.companies[0])
    window._paq.push(['setUserId', this.$store.getters.user.email])
    window._paq.push(['setDocumentTitle', 'Select Company']);
    window._paq.push(['trackPageView']);
  }
},
methods: {
  selectCompany(company) {
    this.$store.dispatch('setUserCompany', company);
    this.trackUserAndCompany(company)
    let slug = company.slug || slugify(company.name)
    this.$router.push({name: 'Home', params: {companySlug: slug}})
  },
  trackUserAndCompany(company) {
    this.$gtag.event('UserPropertyCompany', {
      'event_category': this.$store.getters.user.idUser,
      'company_name': company.name,
      'value': company.name
    })
    this.$gtag.event('Company', {
      'event_category': company.name,
      'company_name': company.name,
      'value': company.name
    })
    this.$gtag.event('UserPropertyIdUser', {
      'event_category': company.name,
      'company_name': company.name,
      'value': this.$store.getters.user.idUser
    })
  }
}
}
</script>

<style scoped>

</style>
